import { numberType } from "types";

import { get, IHttpRequestConfig, remove } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";
import { ILocation } from "@/data/locations";

import { arrayLocationType } from "./types";

const API = {
  hint: "/api/public/locations/autocomplete",
  searchHistory: "/api/search-history/location",
  deleteSearchHistory: "/api/search-history/location/{locationId}",
};

export interface IFetchLocationsHintsSearch extends IURLSearchParams {
  query?: string;
  filtered?: boolean;
  companyId?: number;
  authenticated?: boolean;
}

export const fetchLocationsHints = async (query: IFetchLocationsHintsSearch, options?: IHttpRequestConfig) => {
  const url = compose(API.hint, {}, query);
  return get<ILocation[]>(url, options).then(extractDataFromResponse).then(arrayLocationType);
};

export const fetchLocationSearchHistory = async (params: IFetchLocationsHintsSearch, options?: IHttpRequestConfig) => {
  const { companyId, ...searchParams } = params;
  const url = compose(API.searchHistory, {}, searchParams);
  return get<ILocation[]>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(arrayLocationType);
};

export interface IDeleteLocationsHintsSearch {
  locationId: number;
  companyId?: number;
}

export const deleteLocationSearchHistory = async (
  params: IDeleteLocationsHintsSearch,
  options?: IHttpRequestConfig,
) => {
  const { companyId, locationId } = params;
  const url = compose(API.deleteSearchHistory, { locationId });
  return remove<number>(url, {}, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(numberType);
};
